import { z } from "zod";

export const MaterialImageSchema = z.object({
  assetUrl: z.string(),
  description: z.string().nullish(),
  capturedBy: z.string().nullish(),
  capturedAt: z.date().nullish(),
});

export type MaterialImageSchema = z.TypeOf<typeof MaterialImageSchema>;
